import { Record } from 'immutable';

import { resolve } from '../helpers/LinkMapper';


var Setter = new Record({
    code: null,
    name: null,
});

Setter.fromJSON = function (json) {
    json = json || {};

    const { code, name } = resolve(json).with(Object);

    return new Setter({
        code,
        name
    });
};

export default Setter;
